import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.isDisabled ? '0.5' : '1')};
`;

export const CheckboxContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 12px;
  flex-shrink: 0;
`;

export const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  height: 100%;
  margin: 0;
`;

export const CheckboxCustom = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${(props) => (props.checked ? '#1a1a1a' : '#e0e0e0')};
  border-radius: 6px;
  background-color: ${(props) => (props.checked ? '#1a1a1a' : 'white')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};

  ${CheckboxInput}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  }

  ${CheckboxInput}:hover:not(:disabled) + & {
    border-color: #b0b0b0;
  }
`;

export const CheckboxIcon = styled.span`
  color: white;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
`;

export const CheckboxLabel = styled.label`
  font-size: 16px;
  color: #1a1a1a;
  font-family: 'Inter', sans-serif;
  line-height: 1.5;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  padding-top: 1px;
`;
